// Full journeys catalogue — Planet Air Adventure

const IMG = {
  monastery:
    "https://images.unsplash.com/photo-1729180253317-93ba9cf4ceb4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  trekking:
    "https://images.unsplash.com/photo-1645033393602-4f7623917853?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  festival:
    "https://images.unsplash.com/photo-1667984849405-9d779b049d74?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  peaks:
    "https://images.unsplash.com/photo-1584395631446-e41b0fc3f68d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  mistyRidge:
    "https://images.unsplash.com/photo-1605649487212-47bdab064df7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  prayerFlags:
    "https://images.unsplash.com/photo-1571401835393-8c5f35328320?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  stupaRidge:
    "https://images.unsplash.com/photo-1544735716-392fe2489ffa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  snowPeak:
    "https://images.unsplash.com/photo-1533130061792-64b345e4a833?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  aboveClouds:
    "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  sunsetWater:
    "https://images.unsplash.com/photo-1553856622-d1b352e9a211?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const CATEGORIES = ["All", "Culture", "Trek", "Festival", "Luxury", "Wellness"];

export const JOURNEYS = [
  {
    slug: "cultural-circuit",
    category: "Culture",
    number: "01",
    title: "The Cultural Circuit",
    subtitle: "Paro · Thimphu · Punakha",
    duration: "7 nights",
    from: "USD 1,890",
    perPerson: "per person · twin share",
    difficulty: "Easy",
    season: "Year-round · best Oct–Apr",
    groupSize: "Private · 1–8 travellers",
    img: IMG.monastery,
    gallery: [IMG.monastery, IMG.mistyRidge, IMG.prayerFlags],
    intro:
      "The definitive first journey into Bhutan. A slow tour through the three sacred western valleys — dzongs at dawn, hand-woven textiles, monk chants at dusk — ending with the pilgrimage to Taktsang, the Tiger's Nest.",
    highlights: [
      "Hike to Taktsang Monastery — the Tiger's Nest",
      "Punakha Dzong at the confluence of two rivers",
      "Dochula Pass and its 108 chortens at 3,100m",
      "Home-cooked farmhouse dinner with a Bhutanese family",
      "Weekend market and giant Buddha Dordenma in Thimphu",
    ],
    itinerary: [
      { day: 1, title: "Arrive Paro → Thimphu", detail: "Land at Paro (PBH) on one of the world's most dramatic descents. Drive one hour along the Pachu river to Thimphu. Evening stroll along Norzin Lam and welcome dinner." },
      { day: 2, title: "Thimphu — the capital without traffic lights", detail: "Buddha Dordenma, Memorial Chorten, the Royal Textile Academy and the weekend market. Afternoon visit to a traditional paper-making workshop." },
      { day: 3, title: "Thimphu → Punakha via Dochula", detail: "Cross Dochula Pass (3,100m) with its 108 chortens and — on clear days — a 180° Himalayan panorama. Descend into the subtropical Punakha valley." },
      { day: 4, title: "Punakha Dzong & the river valley", detail: "Morning at Punakha Dzong, arguably the most beautiful fortress in the Himalaya. Gentle walk to Chimi Lhakhang through mustard fields and rice paddies." },
      { day: 5, title: "Punakha → Paro", detail: "Return west over Dochula. Afternoon in Paro town — the National Museum in the round Ta Dzong watchtower and Rinpung Dzong at golden hour." },
      { day: 6, title: "Taktsang — the Tiger's Nest", detail: "The pilgrimage day. A 4–5 hour round hike to the monastery clinging to a 900m cliff face. Tea at the cafeteria viewpoint, blessings inside the temple." },
      { day: 7, title: "Farmhouse & hot-stone bath", detail: "Kyichu Lhakhang, one of Bhutan's oldest temples, then a farewell farmhouse dinner with ara (rice spirit) and a traditional hot-stone bath." },
      { day: 8, title: "Depart Paro", detail: "Private transfer to Paro International Airport. Tashi delek — until next time." },
    ],
    includes: [
      "All Sustainable Development Fees (SDF) & Bhutan visa",
      "Licensed English-speaking cultural guide",
      "Private SUV with dedicated driver",
      "3★ boutique hotels (4–5★ upgrades available)",
      "All meals — hotel, farmhouse & curated local restaurants",
      "All monument & museum entry fees",
      "Airport transfers & 24h on-ground support",
    ],
    excludes: [
      "International airfare into Paro (we book it — ask us)",
      "Travel insurance (strongly recommended)",
      "Drinks, laundry & personal expenses",
      "Gratuities for guide & driver (discretionary)",
    ],
  },
  {
    slug: "druk-path-trek",
    category: "Trek",
    number: "02",
    title: "Druk Path Trek",
    subtitle: "Paro → Thimphu · alpine",
    duration: "9 nights",
    from: "USD 2,450",
    perPerson: "per person · full camp support",
    difficulty: "Moderate–hard · max 4,210m",
    season: "Mar–May · Sep–Nov",
    groupSize: "Small group · 2–8 trekkers",
    img: IMG.trekking,
    gallery: [IMG.trekking, IMG.prayerFlags, IMG.mistyRidge],
    intro:
      "Bhutan's classic high route: six trekking days between Paro and Thimphu across rhododendron forests, yak pastures and a chain of turquoise alpine lakes at 4,200m — with full camps, a local trail crew and a certified mountain guide.",
    highlights: [
      "Camp beside the sacred lakes of Jimilang Tsho & Simkotra Tsho",
      "Sunrise view of Gangkar Puensum — the world's highest unclimbed peak",
      "Ancient Jele Dzong on its lonely ridge",
      "Acclimatisation hike to Tiger's Nest before the trail",
      "Full camp crew — cooks, horsemen, dining tent",
    ],
    itinerary: [
      { day: 1, title: "Arrive Paro", detail: "Gear check with your mountain guide, short walk around Paro town, early night at altitude (2,280m)." },
      { day: 2, title: "Acclimatisation — Tiger's Nest hike", detail: "The 900m ascent to Taktsang doubles as perfect acclimatisation. Evening briefing on the route ahead." },
      { day: 3, title: "Trek day 1 — Paro to Jele Dzong", detail: "A steady climb through blue pine forest to camp just below Jele Dzong (3,480m). First night under canvas." },
      { day: 4, title: "Trek day 2 — Jele Dzong to Jangchulakha", detail: "Ridge walking through thick rhododendron. Yak herder camps, views over the Paro valley. Camp at 3,770m." },
      { day: 5, title: "Trek day 3 — to Jimilang Tsho", detail: "Descend to the shore of Jimilang Tsho, a lake famous for giant golden trout. Camp at 3,870m beside the water." },
      { day: 6, title: "Trek day 4 — to Simkotra Tsho", detail: "Past Janetso lake and abandoned yak camps to Simkotra Tsho (4,110m). The wildest camp of the route." },
      { day: 7, title: "Trek day 5 — Phajoding via the high point", detail: "Cross the 4,210m high point — on clear mornings, Gangkar Puensum fills the horizon. Descend to Phajoding monastery." },
      { day: 8, title: "Trek day 6 — descend to Thimphu", detail: "A knee-testing descent through pine forest into the capital. Hot shower, massage, celebration dinner." },
      { day: 9, title: "Thimphu — recovery day", detail: "Slow morning. Buddha Dordenma, cafés and the textile museum, or simply rest." },
      { day: 10, title: "Depart Paro", detail: "Morning drive to the airport and departure." },
    ],
    includes: [
      "All SDF fees & Bhutan visa",
      "Certified high-altitude mountain guide",
      "Full camp: sleeping & dining tents, mats, cook crew, horsemen & pack animals",
      "All trek meals + hotel nights in Paro & Thimphu",
      "Emergency oxygen & first-aid kit on trail",
      "Private transfers throughout",
    ],
    excludes: [
      "International airfare into Paro",
      "Personal trekking gear (rental list provided)",
      "Travel & high-altitude insurance (mandatory)",
      "Tips for trail crew",
    ],
  },
  {
    slug: "tsechu-festival-journey",
    category: "Festival",
    number: "03",
    title: "Tsechu Festival Journey",
    subtitle: "Paro · Thimphu · Bumthang",
    duration: "8 nights",
    from: "USD 2,190",
    perPerson: "per person · festival season",
    difficulty: "Easy",
    season: "Timed to Paro (Mar/Apr) or Thimphu (Sep/Oct) Tsechu",
    groupSize: "Private · 1–10 travellers",
    img: IMG.festival,
    gallery: [IMG.festival, IMG.monastery, IMG.stupaRidge],
    intro:
      "Bhutan at its most theatrical. Reserved courtyard seats at the great masked-dance festivals, timed precisely to the lunar calendar by our festival specialists — plus the valleys, dzongs and farmhouses in between.",
    highlights: [
      "Two full days of cham masked dances from reserved seats",
      "The unfurling of the giant thongdrel at dawn",
      "Atsara (sacred clown) encounters in the crowd",
      "Festival dress: wear a kira or gho fitted for you",
      "Photography briefing from a local documentary photographer",
    ],
    itinerary: [
      { day: 1, title: "Arrive Paro", detail: "Arrival, fitting of your gho or kira for festival days, and an evening walk through Paro's shuttered wooden shopfronts." },
      { day: 2, title: "Festival day one", detail: "Early entry to the dzong courtyard. Cham dances of the Eight Manifestations of Guru Rinpoche. Picnic lunch amid the crowds." },
      { day: 3, title: "Festival day two — the thongdrel", detail: "Pre-dawn arrival for the unfurling of the four-storey silk thongdrel, taken down before sunlight touches it. Afternoon at leisure." },
      { day: 4, title: "Paro → Thimphu", detail: "Drive to the capital. Textile academy, the giant Buddha and an evening archery match — Bhutan's national obsession." },
      { day: 5, title: "Thimphu → Punakha", detail: "Over Dochula pass to the winter capital. Punakha Dzong, where the festival tradition began in 1670." },
      { day: 6, title: "Punakha valley", detail: "Morning suspension-bridge walk and a river-side picnic. Optional gentle rafting on the Mo Chhu." },
      { day: 7, title: "Return to Paro", detail: "Back over the passes. Farewell dinner in a heritage farmhouse with butter tea and ara." },
      { day: 8, title: "Tiger's Nest", detail: "The pilgrimage hike to Taktsang — quieter now the festival crowds have gone." },
      { day: 9, title: "Depart Paro", detail: "Transfer to the airport for departure." },
    ],
    includes: [
      "All SDF fees & Bhutan visa",
      "Reserved festival courtyard seating (arranged months ahead)",
      "Cultural guide specialised in festival iconography",
      "Traditional dress rental for festival days",
      "Boutique hotels, all meals & private vehicle",
    ],
    excludes: [
      "International airfare into Paro",
      "Travel insurance",
      "Camera fees where applicable",
      "Personal expenses & tips",
    ],
  },
  {
    slug: "jomolhari-base-camp",
    category: "Trek",
    number: "04",
    title: "Jomolhari Base Camp",
    subtitle: "Paro → Jangothang · 4,080m",
    duration: "11 nights",
    from: "USD 3,150",
    perPerson: "per person · expedition support",
    difficulty: "Hard · max 4,890m",
    season: "Apr–Jun · Sep–Nov",
    groupSize: "Small group · 2–6 trekkers",
    img: IMG.snowPeak,
    gallery: [IMG.snowPeak, IMG.trekking, IMG.aboveClouds],
    intro:
      "The most beautiful base camp in the Himalaya, many say. Seven trekking days up the Paro Chhu valley to Jangothang, where the 7,326m wall of Jomolhari rises straight from your tent door — then over the 4,890m Bhonte La pass.",
    highlights: [
      "Camp two nights at Jangothang beneath Jomolhari's north face",
      "Blue sheep, yaks and — with luck — the elusive snow leopard's tracks",
      "Cross Bhonte La pass at 4,890m",
      "Remote villages of Soe and Takethang, home to yak-herding families",
      "Acclimatisation day with a hike to Tshophu twin lakes",
    ],
    itinerary: [
      { day: 1, title: "Arrive Paro", detail: "Team briefing, gear check and a gentle walk to Rinpung Dzong." },
      { day: 2, title: "Acclimatise — Tiger's Nest", detail: "Hike to Taktsang (3,120m) to wake the legs up. Final packing with the crew." },
      { day: 3, title: "Trek day 1 — Shana", detail: "Drive to Drukgyel Dzong ruins and walk the Paro Chhu river trail to Shana camp (2,850m)." },
      { day: 4, title: "Trek day 2 — Thangthangka", detail: "A long forest day — birch, fir and rhododendron — climbing steadily to 3,610m. First glimpse of Jomolhari at dusk." },
      { day: 5, title: "Trek day 3 — Jangothang base camp", detail: "Above the treeline into yak country. Arrive at Jangothang (4,080m), the ruined fortress beneath the great mountain." },
      { day: 6, title: "Rest day at base camp", detail: "Acclimatisation hike to the twin lakes of Tshophu (4,380m). Blue sheep on the scree, the mountain glowing at sunset." },
      { day: 7, title: "Trek day 5 — over Bhonte La", detail: "The big day: cross Bhonte La at 4,890m, prayer flags snapping in the wind, and descend to Soi Yaktsa camp." },
      { day: 8, title: "Trek day 6 — Takhung La to Thombu", detail: "A second pass (4,520m) with views back to Jomolhari and Jichu Drake. Camp on the Thombu shelf." },
      { day: 9, title: "Trek day 7 — descend to Sharna", detail: "Steep descent back to the Paro valley floor. Drive to Paro, hot-stone bath, real bed." },
      { day: 10, title: "Paro — recovery", detail: "Sleep in. Optional gentle valley cycling or museum afternoon. Celebration dinner." },
      { day: 11, title: "Buffer / cultural day", detail: "Built-in weather buffer — used for Kyichu Lhakhang and Paro town if unneeded on the trail." },
      { day: 12, title: "Depart Paro", detail: "Airport transfer and departure." },
    ],
    includes: [
      "All SDF fees & Bhutan visa",
      "Expedition-grade camp & certified high-altitude guide",
      "Cook crew, horsemen & pack animals",
      "Satellite communicator & emergency oxygen on trail",
      "All meals & hotel nights in Paro",
      "Weather-buffer day built into the route",
    ],
    excludes: [
      "International airfare into Paro",
      "Personal gear & sleeping bag (rentals available)",
      "High-altitude evacuation insurance (mandatory)",
      "Tips for trail crew",
    ],
  },
  {
    slug: "himalayan-honeymoon",
    category: "Luxury",
    number: "05",
    title: "The Himalayan Honeymoon",
    subtitle: "Paro · Punakha · Gangtey",
    duration: "9 nights",
    from: "USD 4,900",
    perPerson: "per person · 5★ lodges",
    difficulty: "Easy",
    season: "Year-round · best Oct–Dec, Feb–Apr",
    groupSize: "Strictly private · 2 travellers",
    img: IMG.aboveClouds,
    gallery: [IMG.aboveClouds, IMG.sunsetWater, IMG.monastery],
    intro:
      "Bhutan, unhurried and utterly private. Nine nights across three valleys in the kingdom's finest lodges — private dinners in candle-lit dzong courtyards, couples' hot-stone baths, and a blessing ceremony performed by monks for your marriage.",
    highlights: [
      "5★ lodge collection — suites with valley views & private terraces",
      "Marriage blessing ceremony at a 7th-century temple",
      "Private candle-lit dinner beneath Punakha Dzong",
      "Couples' traditional hot-stone bath with local herbs",
      "Black-necked crane valley of Gangtey in winter",
      "Helicopter transfer option over the passes",
    ],
    itinerary: [
      { day: 1, title: "Arrive Paro", detail: "Champagne arrival at your lodge overlooking the valley. Slow evening — you've just landed at 2,280m." },
      { day: 2, title: "Paro valley, privately", detail: "A gentle valley walk to Kyichu Lhakhang, where monks perform a traditional blessing ceremony for your marriage." },
      { day: 3, title: "Paro → Punakha", detail: "Over Dochula pass with a private picnic among the chortens, descending into the warm Punakha valley." },
      { day: 4, title: "Punakha — dzong & river", detail: "Punakha Dzong in the soft morning light, then an afternoon drifting the Mo Chhu by private raft. Candle-lit courtyard dinner." },
      { day: 5, title: "Punakha — slow day", detail: "Sunrise yoga on your terrace, spa treatments, and a walk to Khamsum Yulley Namgyal chorten through rice terraces." },
      { day: 6, title: "Punakha → Gangtey", detail: "Climb into the glacial Phobjikha valley, winter home of the black-necked cranes. Evening around the lodge's farmhouse fire." },
      { day: 7, title: "Gangtey nature trail", detail: "The gentle Gangtey nature trail through meadows and pine, monastery visit, and a private hot-stone bath under the stars." },
      { day: 8, title: "Gangtey → Paro", detail: "Return west (or take the helicopter over the passes). Farewell tasting-menu dinner at the lodge." },
      { day: 9, title: "Tiger's Nest, together", detail: "The classic pilgrimage hike — horses available for the first half. Prayer-flag hanging ceremony at the ridge." },
      { day: 10, title: "Depart Paro", detail: "Slow breakfast, private transfer, departure." },
    ],
    includes: [
      "All SDF fees & Bhutan visa",
      "5★ lodges throughout (Six Senses / Amankora tier)",
      "Marriage blessing ceremony & prayer-flag ceremony",
      "Private candle-lit dzong dinner & couples' hot-stone bath",
      "Private guide, driver & luxury SUV",
      "All meals including tasting menus",
    ],
    excludes: [
      "International airfare into Paro",
      "Helicopter transfer (optional add-on, quoted on request)",
      "Spa treatments beyond the included bath",
      "Travel insurance & personal expenses",
    ],
  },
  {
    slug: "wellness-hot-stone-retreat",
    category: "Wellness",
    number: "06",
    title: "Wellness & Hot-Stone Retreat",
    subtitle: "Paro · Thimphu valleys",
    duration: "6 nights",
    from: "USD 2,750",
    perPerson: "per person · twin share",
    difficulty: "Very easy",
    season: "Year-round",
    groupSize: "Private · 1–6 travellers",
    img: IMG.sunsetWater,
    gallery: [IMG.sunsetWater, IMG.mistyRidge, IMG.monastery],
    intro:
      "A week engineered for the nervous system. Traditional Bhutanese medicine consultations, daily meditation with a monk teacher, forest bathing in blue-pine valleys, menla herbal hot-stone baths, and food from the lodge's own gardens.",
    highlights: [
      "Consultation at the Institute of Traditional Medicine",
      "Daily guided meditation with a monk teacher",
      "Three traditional dotsho hot-stone baths with wormwood & khempa herbs",
      "Forest-bathing walks through blue pine and oak",
      "Farm-to-table menus, no screens, no schedule pressure",
    ],
    itinerary: [
      { day: 1, title: "Arrive Paro", detail: "Gentle arrival. Herbal tea consultation, valley-view room, early rest at altitude." },
      { day: 2, title: "Breath & the valley floor", detail: "Sunrise meditation with your monk teacher, then a slow forest-bathing walk along the Paro Chhu. First dotsho hot-stone bath at dusk." },
      { day: 3, title: "Traditional medicine day", detail: "Consultation with a menpa (traditional physician) — pulse reading, dietary guidance, personalised herbal blends." },
      { day: 4, title: "Paro → Thimphu", detail: "A quiet transfer day. Afternoon restorative yoga and an evening chanting session at a city monastery." },
      { day: 5, title: "Mountain silence", detail: "Half-day hike to Phajoding monastery above Thimphu for a silent sitting with the resident monks. Evening massage." },
      { day: 6, title: "Return to Paro", detail: "Final hot-stone bath, journaling session, farewell farm-to-table dinner." },
      { day: 7, title: "Depart Paro", detail: "Sunrise meditation, breakfast, transfer to the airport." },
    ],
    includes: [
      "All SDF fees & Bhutan visa",
      "Wellness-focused boutique lodges",
      "Three traditional hot-stone bath sessions",
      "Daily meditation with monk teacher & traditional medicine consultation",
      "All plant-forward meals, teas & herbal blends",
      "Private guide & vehicle",
    ],
    excludes: [
      "International airfare into Paro",
      "Additional spa & massage treatments",
      "Travel insurance & personal expenses",
    ],
  },
  {
    slug: "eastern-bhutan-explorer",
    category: "Culture",
    number: "07",
    title: "Eastern Bhutan Explorer",
    subtitle: "Bumthang · Mongar · Trashigang",
    duration: "12 nights",
    from: "USD 3,400",
    perPerson: "per person · twin share",
    difficulty: "Easy–moderate · long drives",
    season: "Oct–Apr",
    groupSize: "Private · 2–6 travellers",
    img: IMG.stupaRidge,
    gallery: [IMG.stupaRidge, IMG.prayerFlags, IMG.festival],
    intro:
      "Where almost no one goes. A west-to-east traverse of the whole kingdom — the sacred valleys of Bumthang, the lemongrass hills of Mongar, weaving villages of Khoma, and Trashigang's frontier bazaars — exiting overland through Samdrup Jongkhar.",
    highlights: [
      "Bumthang's four valleys — the spiritual heartland",
      "Thrumshing La pass (3,780m) into the untouristed east",
      "Khoma village — Bhutan's finest kishuthara silk weavers",
      "Overnight with a village family in Radhi, the 'rice bowl of the east'",
      "Cross the entire kingdom west to east",
    ],
    itinerary: [
      { day: 1, title: "Arrive Paro", detail: "Arrival and a first walk along Paro's wooden arcades." },
      { day: 2, title: "Paro → Punakha", detail: "Over Dochula. Punakha Dzong and riverside evening." },
      { day: 3, title: "Punakha → Trongsa", detail: "The dramatic mid-country drive across Pele La pass. Trongsa Dzong — ancestral seat of the monarchy." },
      { day: 4, title: "Trongsa → Bumthang", detail: "Over Yotong La into the four sacred valleys. Visit Jakar Dzong at dusk." },
      { day: 5, title: "Bumthang — Jambay & Kurjey", detail: "The valley's great pilgrimage temples, then Swiss-cheese and honey tasting at the valley's curious dairy." },
      { day: 6, title: "Bumthang — Tang valley", detail: "Day trip to the remote Tang valley: Membartsho (the Burning Lake) and the Ogyen Choling manor museum." },
      { day: 7, title: "Bumthang → Mongar", detail: "The kingdom's wildest road — over Thrumshing La (3,780m) and down through waterfalls into the eastern hills." },
      { day: 8, title: "Mongar → Lhuentse & Khoma", detail: "North to Lhuentse Dzong and the weaving village of Khoma, home of Bhutan's most prized textiles." },
      { day: 9, title: "Mongar → Trashigang", detail: "East to the frontier town of Trashigang, its dzong perched over the Drangme Chhu gorge." },
      { day: 10, title: "Radhi village homestay", detail: "Rice terraces, raw-silk weavers and a night with a farming family — butter tea by the wood stove." },
      { day: 11, title: "Trashigang — bazaars & Gom Kora", detail: "Morning at Gom Kora temple, afternoon among the market stalls where Merak-Sakteng highlanders trade." },
      { day: 12, title: "Descend to Samdrup Jongkhar", detail: "Down through subtropical forest to the Indian border town. Farewell dinner." },
      { day: 13, title: "Depart via Guwahati", detail: "Cross the border and transfer to Guwahati airport (India) — or loop back by domestic flight from Yonphula." },
    ],
    includes: [
      "All SDF fees & Bhutan visa",
      "Licensed guide experienced in the eastern circuits",
      "Private 4WD with dedicated driver",
      "Best available hotels + one curated village homestay",
      "All meals & entry fees",
      "Border exit formalities at Samdrup Jongkhar",
    ],
    excludes: [
      "International airfare (into Paro / out of Guwahati)",
      "Indian visa for the Guwahati exit",
      "Travel insurance & personal expenses",
    ],
  },
  {
    slug: "glimpse-of-bhutan",
    category: "Culture",
    number: "08",
    title: "A Glimpse of Bhutan",
    subtitle: "Paro · Thimphu · essentials",
    duration: "4 nights",
    from: "USD 1,290",
    perPerson: "per person · twin share",
    difficulty: "Easy",
    season: "Year-round",
    groupSize: "Private · 1–8 travellers",
    img: IMG.prayerFlags,
    gallery: [IMG.prayerFlags, IMG.monastery, IMG.mistyRidge],
    intro:
      "Short on days, not on depth. The essential Bhutan in a long weekend — Tiger's Nest, Paro's dzongs, Thimphu's living culture — built for travellers connecting through Delhi, Bangkok or Kathmandu.",
    highlights: [
      "Tiger's Nest hike on a compact itinerary",
      "Rinpung Dzong & the National Museum",
      "Buddha Dordenma and Thimphu's craft bazaar",
      "Farmhouse dinner with a hot-stone bath",
      "Perfect stopover add-on to any South-East Asia trip",
    ],
    itinerary: [
      { day: 1, title: "Arrive Paro → Thimphu", detail: "The famous Paro descent, then an hour's drive to the capital. Evening at the Memorial Chorten among circumambulating elders." },
      { day: 2, title: "Thimphu essentials", detail: "Buddha Dordenma at sunrise, the craft bazaar, textile museum and a lunch of ema datshi done properly. Drive to Paro at dusk." },
      { day: 3, title: "Tiger's Nest", detail: "The full pilgrimage hike to Taktsang monastery — 4–5 hours round trip with tea at the viewpoint." },
      { day: 4, title: "Paro valley", detail: "Kyichu Lhakhang, Rinpung Dzong and a farewell farmhouse dinner with a traditional hot-stone bath." },
      { day: 5, title: "Depart Paro", detail: "Morning transfer to the airport." },
    ],
    includes: [
      "All SDF fees & Bhutan visa",
      "Licensed English-speaking guide",
      "Private vehicle & airport transfers",
      "3★ boutique hotels, all meals",
      "All entry fees",
    ],
    excludes: [
      "International airfare into Paro",
      "Travel insurance",
      "Drinks & personal expenses",
    ],
  },
];

export const getJourney = (slug) => JOURNEYS.find((j) => j.slug === slug);
